/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, facts: NonNullable<unknown> }} Wrapped_Period_Share_SummaryInputs */

const en_us2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`My ${i?.range} on My Pocket Gym: ${i?.facts}.`)
};

const pt_br2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu ${i?.range} no My Pocket Gym: ${i?.facts}.`)
};

const es_419_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mi ${i?.range} en My Pocket Gym: ${i?.facts}.`)
};

const pt_pt2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O meu ${i?.range} no My Pocket Gym: ${i?.facts}.`)
};

const fr_fr2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mon ${i?.range} sur My Pocket Gym : ${i?.facts}.`)
};

const de_de2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mein ${i?.range} bei My Pocket Gym: ${i?.facts}.`)
};

const it_it2_wrapped_period_share_summary = /** @type {(inputs: Wrapped_Period_Share_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il mio ${i?.range} su My Pocket Gym: ${i?.facts}.`)
};

/**
* | output |
* | --- |
* | "My {range} on My Pocket Gym: {facts}." |
*
* @param {Wrapped_Period_Share_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_share_summary = /** @type {((inputs: Wrapped_Period_Share_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Share_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_share_summary(inputs)
	if (locale === "es-419") return es_419_wrapped_period_share_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_share_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_share_summary(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_share_summary(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_share_summary(inputs)
	return en_us2_wrapped_period_share_summary(inputs)
});
export { wrapped_period_share_summary as "wrapped-period.share_summary" }